<template>
    <div>
        <div class="categorie"
            :class="{ 'active': curCategory == key, 'with-image-categorie': cat.groupImages && cat.groupImages.large }"
            v-for="(cat, key) in categories" :key="key" @click="setCurrentCat(key)">
            <img v-if="cat.groupImages && cat.groupImages.large" :src="getImagesURL(cat, 'groupImages', 'large')">
            <span :class="getStyle(primaryDark, cat)" v-text="getProductLanguage(cat, 'groupName')"></span>
        </div>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import LocaleController from '../assets/controllers/LocaleController'
import eventModule from '@/assets/libs/eventModule'

export default {
    name: 'SideBar',
    props: ['categories', 'curCategory'],
    data () {
        return {
            primaryDark: `${getComputedStyle(document.body).getPropertyValue('--primary-dark')}`.trim()
        }
    },
    methods: {
        setCurrentCat: function (curKey) {
            eventModule.$emit('updateButtonCart', true)
            this.$emit('changeCurCat', curKey)
            setTimeout(() => {
                document.getElementsByClassName('categorie active')[0].scrollIntoViewIfNeeded({ behavior: 'smooth' })
            }, 300)
        },
        getImage: function (cat) {
            try {
                return require(`../../static/icons/${cat.groupName.toLocaleLowerCase()}.svg`)
            } catch (error) {
                cat.image = false
                return null
            }
        },
        getImagesURL: function (prod, prop) {
            /* let url = Util.getLocalConfigs('urlIMGOdhenInterface')
            let uri = (prod[prop] && prod[prop].large)
            return uri && (url + uri) */
            return Util.getImagesUrl(prod, prop, 'large')
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        getStyle: function (backgroundColor, cat) {
            const result = {
                'with-image-span': cat.groupImages && !!cat.groupImages.large,
                'color-black': Util.idealTextColor(backgroundColor)
            }
            return result
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.categorie {
    position: relative;
    text-align: center;
    border-bottom: 1px solid @primary-dark;
    border-right: 1px solid @primary-dark;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: @categorie-font-color;
    height: 100%;
    max-height: 230px;
    background-color: @categorie-color;
    transition: all .2s linear;
    height: 230px;

    span {
        font-family: @default-font;
        font-size: 1.4rem;
        overflow: hidden;
        display: inline-block;
        background: var(--categorie-color);
        // color: var(--categorie-font-color);
        bottom: 0;
        left: 0;
        right: 0;
        padding: 15px 5px;
        opacity: .8;
        position: absolute;
    }

    .with-image-span {
        width: 100%;
    }

    // Span sem imagem - centralizado no meio do card
    &:not(.with-image-categorie) span {
        position: static;
        display: flex;
        align-items: center;
        justify-content: center;
        height: auto;
        margin: auto;
    }

    img {
        margin-bottom: 15px;
        height: auto;
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        height: 100%;
        object-fit: cover;
        width: 100%;
    }

    transition: background-color 0.3s ease,
    color 0.3s ease;

    span,
    .with-image-span {
        transition: background-color 0.3s ease, color 0.3s ease;
    }

    .with-image-span.color-black {
        transition: color 0.3s ease, font-weight 0.3s ease;
    }

    &.active {
        background-color: @primary-dark;
        color: @white;

        span {
            background-color: @primary-light;
        }

        .with-image-span {
            background-color: @primary-dark;

            &.color-black {
                color: rgb(0, 0, 0);
                font-weight: bold;
            }
        }
    }
}

.with-image-categorie {
    justify-content: end;
}

@keyframes fadeSlideIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .categorie {
        height: 100%;
        max-height: 170px;
        height: 170px;
        span {
            font-size: 1.2rem;
        }

        // Span sem imagem - centralizado no meio do card (tablet)
        &:not(.with-image-categorie) span {
            position: static;
            display: flex;
            align-items: center;
            justify-content: center;
            height: auto;
            margin: auto;
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .categorie {
        height: 100%;
        max-height: 110px;

        span {
            font-size: 15px;
            padding: 7px 5px;
        }

        // Span sem imagem - centralizado no meio do card (mobile)
        &:not(.with-image-categorie) span {
            position: static;
            display: flex;
            align-items: center;
            justify-content: center;
            height: auto;
            margin: auto;
        }
    }
}
@media (orientation: landscape) {
    .categorie {
        height: 100%;
        max-height: 170px;
        height: 170px;
        span {
            font-size: 1.2rem;
        }

        // Span sem imagem - centralizado no meio do card (tablet)
        &:not(.with-image-categorie) span {
            position: static;
            display: flex;
            align-items: center;
            justify-content: center;
            height: auto;
            margin: auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SideBarGom.vue